import * as React from 'react'
import moment from 'moment'
import { inject, observer } from 'mobx-react'
import { API, ITransferBreakdownReportResponse } from '@getgreenline/homi-shared'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { Currency } from '../../../../../components/Currency'
import { Skeleton } from 'antd'
import { ReportFilter } from '../ReportFilter'
import { ReportFilterStore } from '../ReportFilterStore'
import Helmet from 'react-helmet'
import { Track } from '../../../../../Track'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  reportFilterStore?: ReportFilterStore
}

interface State {
  transferBreakdown?: ITransferBreakdownReportResponse
}

@inject('currentCompanyStore', 'reportFilterStore')
@observer
export class TransfersBreakdown extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.loadReport()
  }

  loadReport() {
    const { startDate, endDate, selectedLocationIds } = this.props.reportFilterStore!
    this.setState({ transferBreakdown: undefined })
    const filter = {
      locationIds: selectedLocationIds,
      startDate: moment(startDate).startOf('day').toDate(),
      endDate: moment(endDate).endOf('day').toDate(),
    }
    const company = this.props.currentCompanyStore!.company!
    Track.startTimer('dashboard:reports_transfers')
    API.getTransfersBreakdown(company.id, filter).then((report) => {
      Track.track('dashboard:reports_transfers', {
        numberOfDays: moment(endDate).diff(startDate, 'days'),
      })
      this.setState({ transferBreakdown: report })
    })
  }

  render() {
    const { transferBreakdown } = this.state

    const helmet = (
      <Helmet>
        <title>Reports | Transfers</title>
        <meta name='page-loaded' content='true' />
      </Helmet>
    )

    if (!transferBreakdown) {
      return (
        <>
          {helmet}
          <Skeleton active />
        </>
      )
    }

    return (
      <>
        {helmet}
        <ReportFilter maxRangeMonths={12} />
        <div className='rounded background-white'>
          <div className='p-3'>
            <div>
              <b>Transfers breakdown</b>
            </div>
            <div className='text-muted'>By location</div>
            <br />
            <table className='table table-sm'>
              <tbody>
                <tr>
                  <th>Location</th>
                  <th className='text-right'>Total outgoing</th>
                </tr>
                {transferBreakdown.data.from.map((transfer) => {
                  return (
                    <tr key={transfer.locationName}>
                      <td>{transfer.locationName}</td>
                      <td className='text-right'>
                        <Currency centValue={transfer.total} />
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <table className='table table-sm'>
              <tbody>
                <tr>
                  <th>Location</th>
                  <th className='text-right'>Total incoming</th>
                </tr>
                {transferBreakdown.data.to.map((transfer) => {
                  return (
                    <tr key={transfer.locationName}>
                      <td>{transfer.locationName}</td>
                      <td className='text-right'>
                        <Currency centValue={transfer.total} />
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </>
    )
  }
}
